<template>
    <div class="card user_notes_modal" :class="{'active': activeModal}">
      <div class="card-header">
        <p class="text-center">{{ trans('note') }}</p>
        <i class="close_note" @click="close"></i>
      </div>
      <textarea :disabled="!edit_mode" maxlength="200" ref="noteTextarea" v-model="note" :placeholder="trans('note_textarea_placeholder')" class="notes_textarea"></textarea>
      <button v-if="!edit_mode" @click="edit()" class="edit-button btn">{{ trans("edit") }}</button>
      <button v-else @click="close" class="edit-button btn">{{ trans("save") }}</button>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    props: ['active', 'user_id', 'noteString'],

    mixins: [
      require('@general/lib/mixin').default
    ],
    computed: {
        ...mapGetters({
        }),
      activeModal: {
        get: function() {
          return this.active
        },
        set: function(value) {
          this.$emit('hideModal', value)
        }
      }
    },
    methods: {
        ...mapActions({
           // hideSidebar: sidebarType.actions.hide,
        }),
      leaveNote() {
        this.close();

        axios.post(`/api/user/note/${this.user_id}`,{
          note : this.note,
        })
            .then((note) => {
              this.$store.state.usersInfo[this.user_id]['note'] = note.data ? note.data : null;
            });
      },
      edit(){
        this.edit_mode = true
        this.$nextTick(()=> {
          this.setCaretPosition(this.$refs['noteTextarea']);
        });
      },
      setCaretPosition(ctrl) {
        ctrl.focus();
        ctrl.setSelectionRange(this.note.length, this.note.length);
      },
      close(){
          this.activeModal = false;
          var self = this;
          //css animation with 0.2sec
          setTimeout(function (){
            self.edit_mode = false;
          },200)
      }
    },

  watch: {
    activeModal: function(activeModal) {
      if(activeModal && !this.note){
        this.edit_mode = true;
        this.$nextTick(()=> {
          this.setCaretPosition(this.$refs['noteTextarea']);
        });
      }
      if(!activeModal){
        this.leaveNote();
      }
    }
  },
  data() {
    return {
      note: this.noteString,
      edit_mode: false
    }
  }
}
</script>
